import React from 'react';
import {useTranslation} from "react-i18next";

interface PeriodNameProps {
    sportId: number;
    periodNumber?: number;
}

export const PeriodName: React.FC<PeriodNameProps> = ({periodNumber, sportId}) => {
    const {t, i18n} = useTranslation();
    if (!periodNumber) {
        return <span/>;
    }
    const key = `period.${sportId}.${periodNumber}`;
    if (i18n.exists(key)) {
        const res = t(key);
        return <span>{res ? res : periodNumber}</span>
    }
    return <span>{periodNumber}</span>;
}